import { useQuery } from "@tanstack/react-query";

import { ChatStatus, ChatType, type ChatChannel } from "@fitness-app/data-models/entities/Chat";

import { useUserRole } from "~/hooks/trainer/useUserRole";
import { supabase } from "~/store/initializeStore";

export const useTraineeChats = (userId?: string | null) => {
  const { userId: trainerUserId } = useUserRole();
  const { data, isLoading } = useQuery(["chat_channels", userId, trainerUserId], {
    enabled: !!userId,
    queryFn: async () => {
      const query = supabase
        .from("chat_channel")
        .select("*")
        .order("updatedAt", { ascending: false })
        .contains("assignedUsers", [userId, trainerUserId])
        .eq("status", ChatStatus.Active)
        // Personal messages from the trainee panel go to the regular conversation — the
        // consumer picks data[0], which used to silently hit the announcement channel
        // whenever it was the more recently touched one (TRE-1947).
        .in("type", [ChatType.TwoWay, ChatType.OneWay])
        .limit(100);

      const { error, data } = await query.returns<ChatChannel[]>();
      if (error) {
        return [];
      }
      return data;
    },
  });

  return {
    isLoading,
    data,
  };
};
